/**
 * My API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface IncentiveRecordsRecordLetterStateModel {
  letterType?: IncentiveRecordsRecordLetterStateModelLetterTypeEnum;
  state?: IncentiveRecordsRecordLetterStateModelStateEnum;
}
export enum IncentiveRecordsRecordLetterStateModelLetterTypeEnum {
  Other = 'Other',
  AdherenceLetter = 'AdherenceLetter',
  TargetAgreementForm = 'TargetAgreementForm',
  TargetAchievementForm = 'TargetAchievementForm',
  MeritAllocation = 'MeritAllocation',
  SpecialRecognitionLetter = 'SpecialRecognitionLetter',
  RestructuringCalculation = 'RestructuringCalculation',
  RestructuringLetter = 'RestructuringLetter'
}
export enum IncentiveRecordsRecordLetterStateModelStateEnum {
  None = 'None',
  Created = 'Created',
  InManagerReview = 'InManagerReview',
  InEmployeeReview = 'InEmployeeReview',
  Published = 'Published',
  ManagerRejected = 'ManagerRejected',
  EmployeeRejected = 'EmployeeRejected',
  NoLetterRequired = 'NoLetterRequired'
}
